import { Notifications } from "@mantine/notifications";

import { HotjarConfig } from "./hotjar";
import { NewRelicConfig } from "./new-relic";

export const ClientConfig = () => {
  return (
    <>
      <HotjarConfig />
      <NewRelicConfig />
      <Notifications containerWidth="max-content" limit={3} />
    </>
  );
};
